import { render, staticRenderFns } from "./CurvedBottomNavigation.vue?vue&type=template&id=02d52b78&scoped=true"
import script from "./CurvedBottomNavigation.vue?vue&type=script&lang=js"
export * from "./CurvedBottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./CurvedBottomNavigation.vue?vue&type=style&index=0&id=02d52b78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d52b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d52b78')) {
      api.createRecord('02d52b78', component.options)
    } else {
      api.reload('02d52b78', component.options)
    }
    module.hot.accept("./CurvedBottomNavigation.vue?vue&type=template&id=02d52b78&scoped=true", function () {
      api.rerender('02d52b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CurvedBottomNavigation.vue"
export default component.exports